import { observable, computed, makeObservable } from 'mobx';

import { optional } from '@vromo/models';

import { Upload } from '@vromo/models';
import { createModelSchema, primitive, object } from 'serializr';

export class BrandPromotion {
    enabled: boolean = false;

    banner: Upload | null = null;
    link: string | null = null;

    constructor() {
        makeObservable(this, {
            enabled: observable,
            banner: observable,
            link: observable,
            absoluteLink: computed
        });
    }

    get absoluteLink() {
        if (this.link) {
            return this.link.startsWith('http') ? this.link : `http://${this.link}`;
        } else {
            return null;
        }
    }
}

createModelSchema(BrandPromotion, {
    enabled: primitive(),
    banner: optional(object(Upload)),
    link: optional(primitive())
});
